require('./card.scss');

//@vendors
const React = require('react');
const PropTypes = require('prop-types');
//@Icons
const ibanIcon = require('assets/icons/headline/iban-desktop.svg');
const correosIcon = require('assets/icons/headline/correos-mobile.svg');
const documentacionIcon = require('assets/icons/headline/documentos-desktop.svg');

const Card = ({ children, icon }) => {
    const availableIcons = {
        iban: ibanIcon,
        correos: correosIcon,
        documentacion: documentacionIcon,
    };

    return (
        <div className="card">
            <div className="card__container">
                <div className="card__container-icon">
                    <img src={availableIcons[icon]} alt="" />
                </div>
                <div className="card__container-content">{children}</div>
            </div>
        </div>
    );
};

Card.propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    iconClassName: PropTypes.string,
    contentClassName: PropTypes.string,
    icon: PropTypes.oneOf(['iban', 'correos', 'documentacion']).isRequired,
};

module.exports.constructor = Card;
module.exports = Card;
